module.exports = __webpack_public_path__ + "b2fbcc12452730a1df97ccf1c0fa2bac.pdf";